import styled from "styled-components";

const ErrorContainer = styled.div`
  border: 1px solid var(--color-primary-dark);
  padding: 1rem;
`;

export default ErrorContainer;
